'use client';
import { css, styled } from 'styled-components';
import { space } from 'styled-system';
import { Box } from '@design-system/box';
import { Card } from '@design-system/card';
import { Image } from '@design-system/image';
import { linkControlledHoverEffect, primaryShadow, responsive, } from '@design-system/theme';
export const WrapperContentStyled = styled(Box).attrs({
    display: 'block',
    px: { _: 4, m: 6, l: '80px', xl: '115px' },
    pt: 4,
    pb: { _: 6, l: 8 },
}) `
  ${primaryShadow};
  ${({ theme }) => css `
    ${responsive('m') `
      border-bottom-left-radius: ${theme.themeVariables.globalBorderRadius}px;
      border-bottom-right-radius: ${theme.themeVariables.globalBorderRadius}px;
    `}
  `}
`;
export const ImageWrapperStyled = styled(Box) `
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6));
  ${({ theme }) => css `
    ${responsive('m') `
      border-top-left-radius: ${theme.themeVariables.globalBorderRadius}px;
      border-top-right-radius: ${theme.themeVariables.globalBorderRadius}px;
    `}
  `}
`;
export const ImageStyled = styled(Image) `
  background-color: white;
  object-fit: cover;
  aspect-ratio: 1600 / 600;
  width: ${(props) => props.width || '100%'};
  height: 100%;

  ${({ theme }) => css `
    ${responsive('m') `border-top-left-radius: ${theme.themeVariables.globalBorderRadius}px;
      border-top-right-radius: ${theme.themeVariables.globalBorderRadius}px;
    `}
  `}
`;
export const HeaderStyled = styled(Box).attrs({
    display: 'block',
    mb: 4,
}) `
  ${({ theme }) => `border-bottom: 1px solid ${theme.colors.horizon};
  `}
`;
export const RelatedContentWrapper = styled(Box).attrs({
    pb: 6,
    pt: 3,
    height: { _: '92px', xl: '118px' },
}) `
  // Inherit Card component's background
  background: inherit;
  box-sizing: content-box;
  border-radius: ${({ theme }) => {
    const br = theme.themeVariables.globalBorderRadius;
    return `0 0 ${br}px ${br}px`;
}};
`;
export const RelatedAnimatedContentBox = styled(Box).attrs(() => ({
    pb: 6,
    pt: 3,
    height: { _: '116px', xl: '118px' },
    flex: 1,
    flexDirection: 'column',
    px: { _: 3, l: 4 },
    zIndex: 0,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    overflow: 'hidden',
})) `
  // Inherit Card component's background
  background: inherit;
  transition: height 0.3s;
  box-sizing: content-box;
  border-radius: ${({ theme }) => {
    const br = theme.themeVariables.globalBorderRadius;
    return `0 0 ${br}px ${br}px`;
}};
`;
export const RelatedImgStyled = styled(Box).attrs({
    width: '100%',
}) `
  transition-duration: 0.3s;
  transition-property: filter, height, transform;
  aspect-ratio: 1600 / 600;
  background-image: url(${({ $previewUrl }) => $previewUrl});

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  ${({ $mediumUrl }) => css `
    ${responsive('m') `
      background-image: url(${$mediumUrl});
    `}
  `}
`;
export const RelatedImgWrapper = styled(Box).attrs({
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
}) `
  background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6));
  border-radius: ${({ theme }) => {
    const br = theme.themeVariables.globalBorderRadius;
    return `${br}px ${br}px 0 0`;
}};
`;
export const RelatedLinkStyled = styled(Box).attrs({
    as: 'h3',
    font: 'h3-semibold',
    marginTop: '0 !important',
    marginBottom: '0 !important',
}) `
  text-decoration: none;
`;
export const RelatedDateStyled = styled(Box).attrs(({ $description }) => ({
    font: 'body-semibold-asphalt',
    mt: 1,
    pb: $description && '6px',
})) ``;
export const RelatedDescription = styled(Box) `
  line-height: 1.5rem;
`;
export const RelatedCardStyled = styled(Card) `
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: 0;
  position: relative;

  @media (hover: hover) {
    & ${RelatedImgStyled} {
      transform: scale(1);
    }

    &:hover ${RelatedImgStyled}, &:focus ${RelatedImgStyled} {
      transform: scale(1.05);
    }

    &:hover ${RelatedLinkStyled}, &:focus ${RelatedLinkStyled} {
      ${linkControlledHoverEffect()}
    }

    &:hover ${RelatedAnimatedContentBox}, &:focus ${RelatedAnimatedContentBox} {
      height: 157px;
    }
  }
`;
export const SocialMediaButtonLi = styled.li `
  display: flex;
  flex-direction: column;
  padding: 4px 12px 4px 0;

  ${space}
`;
export const SocialMediaButtonUl = styled.ul `
  display: flex;
  flex-direction: row;
`;
//# sourceMappingURL=styled.js.map